import { FC } from 'react'

import { SalesDataSourceWebPage } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { useSecondaryMenu } from 'ui/components/BPLayout'

export const Sidebar: FC<{ webPage: SalesDataSourceWebPage }> = ({ webPage }) => {
  const items = webPage
    ? [
        { label: webPage.title, hash: 'main' },
        ...(webPage.uploadedFiles !== undefined ? [{ label: 'Uploaded Files', hash: 'uploaded_files' }] : []),
        ...(webPage.dailyReports !== undefined ? [{ label: 'Daily Metrc Data', hash: 'metrc' }] : []),
        ...(webPage.dailyReportsPOS !== undefined ? [{ label: 'Daily POS Data', hash: 'pos' }] : []),
        ...(webPage.history !== undefined ? [{ label: 'History', hash: 'history' }] : [])
      ]
    : []

  useSecondaryMenu(items)
  return null
}
